export default __webpack_public_path__ + "static/media/imagen.9fd2f4f8.png";